import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

export const getCountryCodeByPhoneNumber = (rawNumber: string) => {
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();

    const phoneNumber = phoneUtil.parseAndKeepRawInput(rawNumber);
    return phoneUtil.getRegionCodeForNumber(phoneNumber) || '';
  } catch {
    return '';
  }
};

const isUsPhoneNumber = (rawNumber: string): boolean => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const phoneNumber = phoneUtil.parseAndKeepRawInput(rawNumber);
  return phoneUtil.getRegionCodeForNumber(phoneNumber) === 'US';
};

export const formatPhoneNumberForDefaultValue = (rawNumber: string) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    // Parse the phone number
    const phoneNumber = phoneUtil.parse(rawNumber);

    // Get the country code
    const countryCode = '+' + phoneNumber.getCountryCode();

    // Format the phone number in the International format
    const formattedNumber = phoneUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);

    // Remove the country code from the beginning of the formatted number
    const numberWithoutCountryCode = formattedNumber.replace(countryCode, '').trim();

    // Combine country code with formatted number
    return `${countryCode} ${numberWithoutCountryCode}`;
  } catch {
    return rawNumber; // Return original string if formatting fails
  }
};

export const formatGlobalPhoneForView = (rawNumber: string): string => {
  if (!rawNumber) return '';
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const number = phoneUtil.parseAndKeepRawInput(
      rawNumber,
      getCountryCodeByPhoneNumber(rawNumber)
    );
    if (!number) return rawNumber;

    if (isUsPhoneNumber(rawNumber)) {
      return phoneUtil.format(number, PhoneNumberFormat.NATIONAL);
    }
    return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
  } catch {
    return rawNumber;
  }
};
